import { render, staticRenderFns } from "./labperformancereport.vue?vue&type=template&id=3ad9cf29&scoped=true&"
import script from "./labperformancereport.vue?vue&type=script&lang=js&"
export * from "./labperformancereport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad9cf29",
  null
  
)

export default component.exports